export default __webpack_public_path__ + "static/media/msp-mssp.6f912ddf.png";